import { useState } from 'react';

interface AvatarSelectorProps {
  selectedAvatar: string;
  onSelect: (avatar: string) => void;
}

const AVATARS = [
  '👦', '👧', '🧒', '👶', '🧑', '😊',
  '🤓', '😎', '🥳', '🦸', '🦄', '🐻',
  '🐱', '🐶', '🦊', '🐼', '🐨', '🦁'
];

export default function AvatarSelector({ selectedAvatar, onSelect }: AvatarSelectorProps) {
  return (
    <div className="grid grid-cols-6 gap-2 mt-2">
      {AVATARS.map((avatar) => (
        <button
          key={avatar}
          type="button"
          onClick={() => onSelect(avatar)}
          className={`
            w-12 h-12 rounded-full flex items-center justify-center text-2xl
            transition-all cursor-pointer border-3
            ${selectedAvatar === avatar
              ? 'border-primary bg-primary bg-opacity-10'
              : 'border-gray-300 bg-gray-100 hover:bg-gray-200'
            }
          `}
        >
          {avatar}
        </button>
      ))}
    </div>
  );
}
